<!-- Template -->

<template>
    <div>
        <p v-show="!hasTickets" class="no-data">Tickets do not exist.</p>

         <table class="table with-header tickets-open with-margin">
            <thead v-show="openTickets.length > 0">
                <tr>
                    <th width="100">Priority</th>
                    <th>Ticket / System</th>
                    <th>Status</th>
                    <th class="r">Date opened</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="t in openTickets" :key="t.id">
                    <td>
                        <span class="priority" :class="t.priorityClass">{{t.priority}}</span>
                    </td>
                    <td>
                        <a class="open-system" @click.prevent="openT(t)">#{{t.id}} {{t.shortSummary}}</a>
                        <p>{{t.dhrNumber}} {{t.productConfiguration}}</p>
                    </td>
                    <td>
                        <p>{{t.status}}</p>
                    </td>
                    <td class="r">
                        <p>{{t.date}}</p>
                    </td>
                </tr>
            </tbody>
        </table>

        <TicketDetailsReadOnly ref="ticketDetails" :showBack="false" />
    </div>
</template>

<!-- Script -->

<script>
    import moment from 'moment';
    import TicketDetailsReadOnly from "@/components/Dialogs/TicketDetailsReadOnly";

    export default {
        name: "TicketsContent",

        props: ["hospital", "tickets", "hasTickets"],

        components: {
            TicketDetailsReadOnly
        },

        data(){
            return {
                openTickets:[]
            }
        },

        watch: {
            tickets: {
                deep: true,
                immediate: true,
                handler(value) {
                    if (value) {                        
                        this.update();
                    }
                }
            }
        },

        computed: {
            ticketDetails(){return this.$refs.ticketDetails;}
        },        

        created() { 
            this.update();
        },

        methods: {
            update(){
                var tickets = this.tickets;
                if(tickets.length > 0){
                    var openedTickets = tickets.filter(function(ticket) {
                        return ticket.statusId == 1;
                    });
                    this.openTickets = this.parseTicketArray(openedTickets);       
                }
            },
            parseTicketArray(array){
                var parsedArray = [];
                
                for(var i = 0; i < array.length; i++){
                    var t = {
                        createdByContact: array[i].createdByContact,
                        createdByContactID: array[i].createdByContactID,
                        date: array[i].statusId == 1 ? moment(array[i].dateOpened).format('DD MMM YYYY'): moment(array[i].dateClosed).format('DD MMM YYYY'),
                        description: array[i].description,
                        dhrNumber: array[i].dhrNumber,
                        id: array[i].id,
                        lastUpdated: moment(array[i].lastUpdated).format('DD MMM YYYY'),
                        ownerId: array[i].ownerId,
                        ownerName: array[i].ownerName,
                        priority: array[i].priority,
                        priorityID: array[i].priorityID,
                        productConfiguration: array[i].productConfiguration,
                        shortSummary:array[i].shortSummary,
                        status: array[i].status,
                        statusId: array[i].statusId,
                        supportTicketNature: array[i].supportTicketNature,
                        supportTicketNatureId: array[i].supportTicketNatureId,
                        systemOperable: array[i].systemOperable,
                        priorityClass:'',
                        createdInPortal: array[i].createdInPortal,
                        contactEmail: array[i].contactEmail
                    }
                    if(array[i].priorityID == 3){
                        t.priorityClass = ' low';
                    }else if(array[i].priorityID == 2){
                        t.priorityClass = ' medium';
                    }else if(array[i].priorityID == 1){
                        t.priorityClass = ' high';
                    }else{
                        t.priorityClass = ' medium';
                    }

                    parsedArray.push(t);
                }

                return parsedArray;
            },

            openT(t){
                this.ticketDetails.show(t)
            }
        }
    };
</script>

